const useTextInputValidation = (fieldName, validationRules = []) => {
  const decimalNumberRegex = /^-?\d+(\.\d+)?$/; // Optimized regex
  const label = fieldName.replace('*', '');

  // Helper function for required validation
  const validateRequired = (val, rule, errorList) => {
    if (rule.type === 'required' && !val.trim()) {
      errorList.push(`${label} ${rule.msg}`);
    }
  };

  // Helper function for number validation
  const validateNumber = (val, rule, errorList) => {
    if (rule.type === 'number' && isNaN(val)) {
      errorList.push(`${label} ${rule.msg}`);
    }
  };

  // Helper function for maxLength validation
  const validateMaxLength = (val, rule, errorList) => {
    if (rule.type === 'maxLength' && val.length > rule.limit) {
      errorList.push(`${label} ${rule.msg}`);
    }
  };

  // Helper function for minLength validation
  const validateMinLength = (val, rule, errorList) => {
    if (rule.type === 'minLength' && val.length < rule.limit) {
      errorList.push(`${label} ${rule.msg}`);
    }
  };

  // Helper function for pattern validation
  const validatePattern = (val, rule, errorList) => {
    if (rule.type === 'pattern') {
      try {
        const regex = new RegExp(rule.regex); // Validate custom regex
        if (!regex.test(val)) {
          errorList.push(`${label} ${rule.msg}`);
        }
      } catch (e) {
        console.error('Invalid regex pattern:', rule.regex);
        errorList.push(`${label} contains an invalid regex pattern.`);
      }
    }
  };

  // Helper function for decimal validation
  const validateDecimal = (val, rule, errorList) => {
    if (rule.type === 'decimal' && !decimalNumberRegex.test(val)) {
      errorList.push(`${label} ${rule.msg}`);
    }
  };

  // Main validation function
  const validate = (val) => {
    let errorList = [];
    const rules = [...validationRules];

    rules.forEach((rule) => {
      validateRequired(val, rule, errorList);
      validateNumber(val, rule, errorList);
      validateMaxLength(val, rule, errorList);
      validateMinLength(val, rule, errorList);
      validatePattern(val, rule, errorList);
      validateDecimal(val, rule, errorList);
    });

    return errorList[0];
  };

  const onChange = (e) => {
    return validate(e);
  };

  return { onChange };
};

export default useTextInputValidation;